import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "@/lib/site";

const sessionId = () => {
  let s = sessionStorage.getItem("scs_session");
  if (!s) { s = Math.random().toString(36).slice(2) + Date.now().toString(36); sessionStorage.setItem("scs_session", s); }
  return s;
};

let current = null;

function leave() {
  if (!current?.id) return;
  const body = JSON.stringify({ id: current.id, seconds: Math.round((Date.now() - current.start) / 1000) });
  navigator.sendBeacon?.(`${API}/track/leave`, new Blob([body], { type: "application/json" }));
  current = null;
}

async function track(path) {
  leave();
  const first = !sessionStorage.getItem("scs_seen");
  sessionStorage.setItem("scs_seen", "1");
  const start = Date.now();
  current = { id: null, start };
  try {
    const r = await fetch(`${API}/track`, {
      method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
      body: JSON.stringify({ path, url: window.location.href, referrer: first ? document.referrer : "", title: document.title,
        session: sessionId(), screen: window.screen?.width, lang: navigator.language, tz: Intl.DateTimeFormat().resolvedOptions().timeZone }),
    });
    const d = await r.json();
    if (current?.start === start) current.id = d.id;
  } catch { /* tracking must never break the site */ }
}

function onClick(e) {
  const a = e.target.closest?.("a[href^='http']");
  if (!a || a.host === window.location.host) return;
  const body = JSON.stringify({ type: "outbound", path: window.location.pathname, target: a.href, session: sessionId() });
  navigator.sendBeacon?.(`${API}/track/event`, new Blob([body], { type: "application/json" }));
}

export function useTracking() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.addEventListener("click", onClick, true);
    window.addEventListener("pagehide", leave);
    return () => { document.removeEventListener("click", onClick, true); window.removeEventListener("pagehide", leave); };
  }, []);
  useEffect(() => {
    // wait for the page to set its title
    const t = setTimeout(() => track(pathname), 800);
    return () => clearTimeout(t);
  }, [pathname]);
}
